var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgFolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3966_145613)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M7.49967 3.33398H9.99967L11.6663 5.00065H15.833C16.275 5.00065 16.699 5.17625 17.0115 5.48881C17.3241 5.80137 17.4997 6.22529 17.4997 6.66732V12.5007C17.4997 12.9427 17.3241 13.3666 17.0115 13.6792C16.699 13.9917 16.275 14.1673 15.833 14.1673H7.49967C7.05765 14.1673 6.63372 13.9917 6.32116 13.6792C6.0086 13.3666 5.83301 12.9427 5.83301 12.5007V5.00065C5.83301 4.55862 6.0086 4.1347 6.32116 3.82214C6.63372 3.50958 7.05765 3.33398 7.49967 3.33398Z",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M14.1667 14.166V15.8327C14.1667 16.2747 13.9911 16.6986 13.6785 17.0112C13.366 17.3238 12.942 17.4993 12.5 17.4993H4.16667C3.72464 17.4993 3.30072 17.3238 2.98816 17.0112C2.67559 16.6986 2.5 16.2747 2.5 15.8327V8.33268C2.5 7.89065 2.67559 7.46673 2.98816 7.15417C3.30072 6.84161 3.72464 6.66602 4.16667 6.66602H5.83333",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3966_145613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgFolders);
export default __webpack_public_path__ + "static/media/svg_folders.a071fc55f4c4cd814ae940bb0941940c.svg";
export { ForwardRef as ReactComponent };